import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';
import React from 'react';
import { UnitCardTypes } from '../UnitCardTypes';
import { RatesComponent } from '../helpers/sections/RatesComponent';
import { AmenitiesComponent } from '../helpers/sections/AmenitiesComponent';
import { useSectionData } from '../../../sections/rentalPage/components/dynamicForm/hooks/dataContext';

export const Accordion = ({
  unitCardsConfig,
  foundData,
  theme = 'dark',
  rate,
  selected,
  iconsList,
  amenitiesList,
  amenitiesHeading,
  unitDetailsHeader = 'Unit Details',
  unitCardAccordianTitle = 'Summary',
  path,
  rentalinfoRes,
}: UnitCardTypes.TUnitCardAccordian) => {
  const { iconOne, iconTwo } = iconsList;
  const ratesInfo = {
    unitCardsConfig,
    foundData,
    selected,
    rate,
    isAccordian: true,
    theme: 'dark',
    iconsList,
    path,
    rentalinfoRes,
  };
  const themeConfig = {
    textColor: 'primary',
    sectionBackgroundColor: 'secondary',
  };
  if (theme === 'dark') {
    themeConfig.textColor = 'secondary';
    themeConfig.sectionBackgroundColor = 'primary';
  }
  const getIcon = (activecomponent: boolean) => {
    return activecomponent ? iconTwo.name : iconOne.name;
  };

  const AccordionItemList = () => {
    const { unitTypeCategory, unitTypeName } = foundData;
    const {
      individualUnitDataContext: { selectedUnitData },
    } = useSectionData();
    return (
      <div className="accordianDetailsSection">
        <div className="accordianDiv">
          <div className="is-hidden-tablet">
            <button
              type="button"
              className={`accordionHeadingSection is-flex flex-direction-row is-justify-content-space-between has-background-${themeConfig.sectionBackgroundColor} ${theme}`}
            >
              <h5
                className={`accordianHeader is-hidden-tablet has-text-weight-bold has-text-${themeConfig.textColor}`}
              >
                {unitDetailsHeader}
              </h5>
              <FontAwesomeIcon
                iconClassName={getIcon(true)}
                iconContextProps={{
                  className: `has-text-${themeConfig.textColor}`,
                }}
              />
            </button>
          </div>

          <>
            <p className="unitTypeHeading">{unitCardsConfig.unitTypeHeading}</p>
            <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
              <div className="unitTypeDiv">
                <p className="unitTypePara has-text-black subtitle1">
                  {unitTypeName}
                </p>
                <p className="unitTypeCategoryPara has-text-black">
                  {unitTypeCategory || ''}
                </p>
              </div>
            </div>
            {selectedUnitData && selectedUnitData.show && (
              <>
                <p className="unitTypeHeading">
                  {unitCardsConfig.unitNumberHeading}
                </p>
                <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
                  <div className="unitTypeDiv">
                    <p className="unitTypePara has-text-black subtitle1">
                      {selectedUnitData.selectedUnitLabel}
                    </p>
                  </div>
                </div>
              </>
            )}
            <AmenitiesComponent
              amenitiesList={amenitiesList}
              amenitiesHeading={amenitiesHeading}
            />
          </>
        </div>
        <RatesComponent {...ratesInfo} />
      </div>
    );
  };

  return (
    <div className="accordionSection">
      <div className="accordionSubSection">
        <button
          type="button"
          className={`accordionHeadingSection is-hidden-mobile is-flex flex-direction-row is-justify-content-space-between has-background-${themeConfig.sectionBackgroundColor} ${theme}`}
        >
          <h5
            className={`accordianHeader is-hidden-mobile has-text-weight-bold has-text-${themeConfig.textColor}`}
          >
            {unitCardAccordianTitle}
          </h5>
        </button>
        <div>
          <AccordionItemList />
        </div>
      </div>
    </div>
  );
};
